import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";

Vue.use(Router);

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
      meta: { hidden: true }
    },
    {
      path: "/404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
      meta: { hidden: true }
    },
    {
      path: "/",
      component: Layout,
      redirect: "/dashboard",
      name: "dashboard",
      children: [
        {
          path: "dashboard",
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"
            ),
          meta: {
            title: "首页"
          }
        }
      ]
    },
    // {
    //   path: "/evimember",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/evimember/index.vue"
    //         ),
    //       meta: {
    //         title: "会员信息"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/currectmember",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/currectmember/index.vue"
    //         ),
    //       meta: {
    //         title: "个人信息"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    {
      path: "/personalcenter",
      component: Layout,
      meta: {
        title: "个人中心"
      },
      children: [
        {
          path: "/currectmember/index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/currectmember/index.vue"
            ),
          meta: {
            title: "个人信息"
            // icon: 'form'
          }
        },
        {
          path: "/eviapp/index",
          component: () =>
            import(/* webpackChunkName: "form" */ "@/views/eviapp/index.vue"),
          meta: {
            title: "我的应用"
            // icon: 'form'
          }
        },
        {
          path: "/evimembercertinfo/index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/evimembercertinfo/index.vue"
            ),
          meta: {
            title: "证书管理"
            // icon: 'form'
          }
        }
      ]
    },
    // {
    //   path: "/identityauth",
    //   component: Layout,
    //   redirect: "/identityauth/index",
    //   meta: {
    //     title: "实名认证"
    //   },
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/identityauth/index.vue"
    //         ),
    //       meta: {
    //         title: "实名认证",
    //         breadcrumb: false
    //         // icon: 'form'
    //       }
    //     },
    //     {
    //       path: "/identityauthDetail/:memberAuthType",
    //       name: "identityauthDetail",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/identityauth/components/identityauthDetail.vue"
    //         ),
    //       meta: {
    //         title: "认证详情",
    //         hidden: true
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/evimembercertinfo",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/evimembercertinfo/index.vue"
    //         ),
    //       meta: {
    //         title: "证书管理"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/eviapp",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(/* webpackChunkName: "form" */ "@/views/eviapp/index.vue"),
    //       meta: {
    //         title: "我的应用"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/evisubject",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "/index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/evisubject/index.vue"
    //         ),
    //       meta: {
    //         title: "主体管理"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    {
      path: "/configmanagement",
      component: Layout,
      meta: {
        title: "配置管理"
      },
      children: [
        {
          path: "/evisubject/index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/evisubject/index.vue"
            ),
          meta: {
            title: "主体管理"
            // icon: 'form'
          }
        },
        {
          path: "/evibusiness/index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/evibusiness/index.vue"
            ),
          meta: {
            title: "业务管理"
            // icon: 'form'
          }
        },
        {
          path: "/evibusinessbehavior/index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/evibusinessbehavior/index.vue"
            ),
          meta: {
            title: "业务行为管理"
            // icon: 'form'
          }
        },
        {
          path: "/evidict/index",
          component: () =>
            import(/* webpackChunkName: "form" */ "@/views/evidict/index.vue"),
          meta: {
            title: "数据字典管理"
            // icon: 'form'
          }
        }
      ]
    },
    {
      path: "/midevidence",
      component: Layout,
      children: [
        {
          path: "index",
          component: () =>
            import(
              /* webpackChunkName: "form" */ "@/views/midevidence/index.vue"
            ),
          meta: {
            title: "存证管理"
            // icon: 'form'
          }
        }
      ]
    },
    // {
    //   path: "/evibusiness",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/evibusiness/index.vue"
    //         ),
    //       meta: {
    //         title: "业务管理"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/evibusinessbehavior",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "form" */ "@/views/evibusinessbehavior/index.vue"
    //         ),
    //       meta: {
    //         title: "业务行为管理"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    // {
    //   path: "/evidict",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "index",
    //       component: () =>
    //         import(/* webpackChunkName: "form" */ "@/views/evidict/index.vue"),
    //       meta: {
    //         title: "数据字典管理"
    //         // icon: 'form'
    //       }
    //     }
    //   ]
    // },
    {
      path: "*",
      redirect: "/404",
      meta: { hidden: true }
    }
  ]
});
